module.exports = __webpack_public_path__ + "media/nocode-auto.17ffb523.mp4";